import moment from 'moment/moment'
import { doGetAllTpvAuditListnNCScore, doGetFormattedTpvSelectData, doGetTpvAllAuditPlan, UpdateAuditPlan, CreateAuditPlan, AuditPlanList, doGetFormattedTpvNcScore, CreateTpvNC, getFormattedAllNcList, doGetAllTpvNCList, fetchNCGivenAuditorId, UpdateTpvNC, doGetTpvNCDetailsGivenParams} from './actions/tpvService'
import { doGetAuditorList } from '../Auditor/actions/auditorService';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import Header from '../Header'
import Footer from '../Footer';
import Menu from '../Menu'
import Spinner from '../../UIComponents/Spinner/Spinner';
import { Table, Select, Modal, DatePicker, notification, Checkbox, Tooltip} from 'antd';
import { DeleteOutlined, CheckOutlined, PlusOutlined, EyeOutlined, UploadOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import IconButton from '@mui/material/IconButton';
import TpvScoreBoard from './TpvScoreBoard';
import usePDFExport from '../../../hooks/usePDFExport';
import PrintModal from '../../helpers/shared/PrintModal';
import { Config } from '../../config/config';
import Cookie from 'js-cookie';
import usePrintModal from '../../../hooks/usePrintModal'
import { ApiGateWay } from '../../ApiGateWay/ApiGateWay'
import dayjs from 'dayjs';
const { Option } = Select;

/**
 * NOTE: PENDING
 * 1. Validate if audit plan adheres contract info (contract date, scopes, stores selected etc)
 */

export default function TpvList() {
    // this bUser is isUserAuditor
    const [isUserAuditor, setIsUserAuditor] = useState(true)
    const tpvList = useSelector(state => state?.tpvList.TpvAuditData);
    const tpvNcViewList = useSelector(state => state?.tpvList.TpvNcViewList);
    const auditorList = useSelector(state => state?.auditorList?.AuditorDetails); //auditor
    const status = useSelector(state => state?.tpvList);
    const pdfPageIds = ["#tpvFilter","#tpvScoreBoard"];
    const { printDocument } = usePDFExport([],pdfPageIds, 'TPV Score Board.pdf');
    const { 		
      showPrintModal,
      printFileURL,
      closeModal,
      handleExport,
      printLoading,
      modalTitle
    } = usePrintModal();
    const dispatch = useDispatch();
    const title = "TPV Audit Planner";
    const config = JSON.parse(Config);
    const apiInterface = config['api1'];
    const AuditStatus = [
      {
        id: 1,
        status: "OPEN AUDIT PLANNED",
      },
      {
        id: 2,
        status: "OPEN AUDIT COMPLETED",
      },
      {
        id: 3,
        status: "CLOSURE AUDIT PLANNED",
      },
      {
        id: 4,
        status: "CLOSURE AUDIT COMPLETED"
      },
    ];
    const NCScoreCellColor = {
      "open_low": 'rgb(165 205 20)',
      "open_medium": 'rgb(239 217 0)',
      "open_high": 'rgb(247 146 136)',
      "close_low": 'rgb(218, 239, 143)',
      "close_medium": 'rgb(255 239 91)',
      "close_high": 'rgb(255, 217, 213)',
      "landlord_open": 'rgb(90 203 227)',
      "landlord_closed": 'rgb(162 231 246)'
    }
    const ncClosureUpdateMap = [
      "CLOSE",
      "OPEN"
    ]
    useEffect(() => {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (currentUser && currentUser.roles) {
        setIsUserAuditor(currentUser.roles.includes('Auditor'));
      }
    }, []); 
    const [searchedItem, setSearchedItem] = useState({
        state: [],
        city: [],
        projectScopeId: [],
        auditorId: null,
        storeId : [],
        startDate: null,
        endDate: null
    });
    let filterParams = [ "auditorId", "stateId", "cityId", "storeId", "projectScopeId"]; // zone, state, projectScopeId, auditorId, storeId
    const [auditPlanFilter, setAuditPlanFilter] = useState({
      storeId: undefined,
      auditorId: undefined
    });
    const [auditPlanForm, setAuditPlanForm] = useState([]);
    const [tpvNCForm, setTpvNCForm] = useState({});
    const [auditPlanFormOriginal, setAuditPlanFormOrignal] = useState([]);
    const [auditPlanSelectData, setAuditPlanSelectData] = useState([]);
    const [auditorContractMapped, setAuditorContractMapped] = useState([]);

    /**
     * NOTE: setIsAuditPlanCreate
     * TrueIF: both dropdown selected (auditor & store)
     * TrueIF: no audit plan exists for above selection
     * FalseIF: initial state
     * FalseIF: dropdown changes
     * FalseIF: after audit plan submit
     * UsedFor: to create audit plan
     * UsedFor: to enable submit button
     */
    const [isAuditPlanCreate, setIsAuditPlanCreate] = useState(false);
    const [enableAuditPlanSubmit, setEnableAuditPlanSubmit] = useState(false);
    const [isAuditPlanEditMode, setIsAuditPlanEditMode] = useState(false);
    const [NCModalVisible, setNCModalVisible] = useState(false);
    const [auditPlanLoading, setAuditPlanLoading] = useState(true);
    const [NCTableLoading, setNCTableLoading] = useState(true);
    const [NCScoreLoading, setNCScoreLoading] = useState(true);
    const [selectAllStore,setAllStore] = useState(false);
    const [auditPlanSelectedOption, setAuditPlanSelectedOption] = useState({
      projectScope : null,
      store : null,
      auditStatus : null,
      auditStartDate : null,
      auditClosureDate : null
    });
    const [ncExcel, setNCExcel] = useState(null);
    const [NCScoreTableData, setNCScoreTableData] = useState();
    const [NCLandLordScoreTableData, setNCLandLordScoreTableData] = useState();
    const [formattedAllNC, setFormattedAllNC] = useState([]);
    const [copyFormattedAllNC, setCopyFormattedAllNC] = useState([]);
    const [selectAllNC, setSelectAllNC] = useState(false);
    const originalFilteredNC = useRef([]);
    const isHandleSearchTriggeredRef = useRef(null);
    const [NCPageState, setNCPageState] = useState({
      currentPage: 1,
      pageSize: 10
    })
    const ncPagination = {
      pageSize: NCPageState.pageSize, // Set the number of items per page
      current: NCPageState.currentPage, // Set the current page
      onChange: (page, pageSize) => {
        // Handle page change here, e.g., fetch and display data based on the new page and pageSize
        console.log(`Page: ${page}, PageSize: ${pageSize}`);
        setNCPageState({ currentPage: page, pageSize: pageSize });
      },
    };
    useEffect(() => {
      dispatch(doGetAuditorList());
      //get tpv audit plan api call
      dispatch(doGetAllTpvAuditListnNCScore());
      //get all nc list
      dispatch(doGetAllTpvNCList());
    }, [])
    useEffect(() => {
      //NOTE: change the api
      //getting all state, city & store from auditor contract -> GET api of Auditor 
      let AuditPlanSelectData = doGetFormattedTpvSelectData(auditorList)
      setAuditPlanSelectData(AuditPlanSelectData);
      setAuditorContractMapped(AuditPlanSelectData);
    }, [auditorList])
    useEffect(()=> {
      setIsAuditPlanCreate(false);
      if((auditPlanFormOriginal != undefined && auditPlanFormOriginal.length) || (auditPlanFilter.storeId != undefined && auditPlanFilter.auditorId != undefined))
        handleAuditPlanFilter().then(()=> {
          setAuditPlanLoading(false);
        })
      else if(!auditPlanFormOriginal?.length)
        setAuditPlanLoading(false); //dont want to keep it loading
    }, [auditPlanFilter, auditPlanFormOriginal])
    useEffect(()=> {
      //get the all audit plan data
      let allAuditPlan = doGetTpvAllAuditPlan(tpvList);
      if(allAuditPlan) //dont set undefined
        setAuditPlanFormOrignal(allAuditPlan);
      //set the tpv NC score
      const [allTpvNCScore,allLandLoadNCScore]= doGetFormattedTpvNcScore(tpvList?.TpvNCScore, tpvList?.TpvLandLordNCScore);
        if(allTpvNCScore){
          setNCScoreTableData(allTpvNCScore);
          setNCScoreLoading(false);
        }
        if(allLandLoadNCScore){
          setNCLandLordScoreTableData(allLandLoadNCScore);
          setNCScoreLoading(false);
        }
    },[tpvList]);

    useEffect(()=> {
      //no search filter should be applied when modal is already viewed
      if(NCModalVisible) return;
      let filteredData = []; 
      if(!isHandleSearchTriggeredRef.current) return;
      if(!(searchedItem?.auditorId || searchedItem?.stateId || searchedItem?.cityId || searchedItem?.storeId?.length || searchedItem?.projectScopeId?.length || searchedItem?.startDate || searchedItem?.endDate)){
        const [allTpvNCScore,allLandLoadNCScore]= doGetFormattedTpvNcScore(tpvList?.TpvNCScore, tpvList?.TpvLandLordNCScore);
        if(allTpvNCScore){
          setNCScoreTableData(allTpvNCScore);
          setNCScoreLoading(false);
        }
        if(allLandLoadNCScore){
          setNCLandLordScoreTableData(allLandLoadNCScore);
          setNCScoreLoading(false);
        }
        return;
      }
      //call filter function
      if(formattedAllNC?.length){
        filteredData = filterRecursively(filterParams[0], 0);
        //filter by date
        if(searchedItem.startDate && searchedItem.endDate)
          filteredData = filterByDate(filteredData)
      }
      isHandleSearchTriggeredRef.current = false;
      //handle post filter
      handlePostSearch(filteredData);
    },[formattedAllNC])
    useEffect(()=> {
      let allFormattedNCList = getFormattedAllNcList(tpvNcViewList);
      if(allFormattedNCList){ //default set for all_nc_list without filter
        setFormattedAllNC(allFormattedNCList);
        setCopyFormattedAllNC(allFormattedNCList);
        // setNCScoreLoading(false);
      }
    },[tpvNcViewList])
    const _doCloseNCModal = () => {
        setSelectAllNC(false);
        setNCModalVisible(false);
        setTpvNCForm([]);
    }
    const _doOpenNCModal = () => {
      setNCModalVisible(true);
    }
    const _doSubmitTpvNC = () => {
      //updates only auditor closure status
      //remove unwanted
      const data2Update = [...formattedAllNC];
      const copyOfOriginal = [...formattedAllNC];
      data2Update.forEach((item)=> {
        delete item.editable;
        delete item.projectScopeName;
        delete item.storeName;
      })
      setTpvNCForm([]);
      setIsAuditPlanEditMode(false);
      //call api
      dispatch(UpdateTpvNC(data2Update, copyOfOriginal));
    }

    const _doSubmitAuditPlan = () => {
      /**
       * 1.check if the audit plan contains any existing entries
       * 2.if TRUE: make separate filter new data & make sure existing data is already updated
       * 3.if FALSE: all data is new make create api call
       */
      let newAuditPlanData = auditPlanForm.filter((auditPlan)=> auditPlan.auditDetailId == undefined);
      let auditPlan2Send;
      newAuditPlanData = auditPlanSelectData.map((item) => {
        return newAuditPlanData.map((planForm)=> {
          return item?.store?.map((store)=> {
            if (item.auditorId === planForm.auditorId && store.codeId == planForm.storeId) {
              auditPlan2Send = {
                projectScopeId: planForm?.projectScopeId?.toString(),
                auditDate: planForm?.auditStartDate,
                closureDate: planForm?.auditClosureDate,
                openDocumentmapbase64: planForm?.openDocumentmapbase64,
                closureDocumentmapbase64: planForm?.closureDocumentmapbase64,
                openDocument: planForm?.openDocument,
                closureDocument: planForm?.closureDocument,
                auditStatus: planForm?.auditStatus,
                storeId: planForm?.storeId,
                state: store.state.toString(),
                city: store.city.toString(),
                auditorId: planForm?.auditorId
              };
              return auditPlan2Send;
            }
          }).filter((item)=> item !=undefined)
        }).flat();
      }).filter((item) => item.length > 0).flat();
      for (let index = 0; index < newAuditPlanData.length; index++) {
        if(newAuditPlanData[index].openDocumentmapbase64 == null) delete newAuditPlanData[index].openDocumentmapbase64;
        if(newAuditPlanData[index].closureDocumentmapbase64 == null) delete newAuditPlanData[index].closureDocumentmapbase64;
      }
      dispatch(CreateAuditPlan(newAuditPlanData));
    }
    const handleAuditPlanUpdate = (record, index) => {
      /**NOTE: check column permissions if editable for user logged in
       * TODO:
       * 1. set loading true
       * 2. format data in required format
       * 3. make put api call to update
       * 4. set loading false
       * 5. if api call success update with new data
       * 6. if api call failed show error message and persist old data
       */
      // if(!record?.openDocumentmapbase64 || !record?.closureDocumentmapbase64) return showValidationWarning("Please upload the document", "bottomRight");
      let auditPlan2Send;
      const updatedData = auditPlanForm.map((item, idx) => {
        if (idx === index) { //does not exist if create is true
          //update with edited values
          auditPlan2Send = {
            ...item,
            editable: !item.editable,  
            projectScopeId: auditPlanSelectedOption?.projectScope !=null?auditPlanSelectedOption?.projectScope?.id : item.projectScopeId,
            projectScopeName: auditPlanSelectedOption?.projectScope !=null?auditPlanSelectedOption?.projectScope?.name : item.projectScopeName,
            storeId: auditPlanSelectedOption?.store !=null?auditPlanSelectedOption?.store?.id : item.storeId,
            storeName: auditPlanSelectedOption?.store !=null?auditPlanSelectedOption?.store?.name : item.storeName,
            auditStatus: auditPlanSelectedOption?.auditStatus !=null?auditPlanSelectedOption?.auditStatus?.id : item.auditStatus,
            auditStartDate: auditPlanSelectedOption?.auditStartDate !=null?auditPlanSelectedOption?.auditStartDate : item.auditStartDate,
            auditClosureDate: auditPlanSelectedOption?.auditClosureDate !=null?auditPlanSelectedOption?.auditClosureDate : item.auditClosureDate,
            openDocument: record?.openDocument !=null?record?.openDocument : item.openDocument,
            openDocumentmapbase64: record?.openDocumentmapbase64 !=null?record?.openDocumentmapbase64 : item.openDocumentmapbase64,
            closureDocument: record?.closureDocument !=null?record?.closureDocument : item.closureDocument,
            closureDocumentmapbase64: record?.closureDocumentmapbase64 !=null?record?.closureDocumentmapbase64 : item.closureDocumentmapbase64,
          };
          return auditPlan2Send;
        }
        return item;
      });

      //update with appropriate values and remove values not required.
      auditPlan2Send = {
        ...auditPlan2Send,
        auditDate: auditPlan2Send.auditStartDate,
        closureDate: auditPlan2Send.auditClosureDate,
      }
      delete auditPlan2Send.auditStartDate;
      delete auditPlan2Send.auditClosureDate;
      delete auditPlan2Send.projectScopeName;
      delete auditPlan2Send.storeName;
      delete auditPlan2Send.auditPlanId;
      delete auditPlan2Send.closurDate;
      if(auditPlan2Send.openDocumentmapbase64 == null) delete auditPlan2Send.openDocumentmapbase64;
      if(auditPlan2Send.closureDocumentmapbase64 == null) delete auditPlan2Send.closureDocumentmapbase64;


      setAuditPlanSelectedOption({
        ...auditPlanSelectedOption,
        projectScope : null,
        // store : null,  dont set this to null as it should persist for next entries also
        auditStatus : null,
        auditStartDate : null,
        auditClosureDate : null
      })
      if(record.auditDetailId == undefined){
        setAuditPlanForm(updatedData);
        if(!auditPlan2Send?.projectScopeId || !auditPlan2Send?.auditDate){
          updatedData[index].editable = !updatedData[index].editable
          setAuditPlanForm(updatedData);
          return showValidationWarning("Project Scope & Start Date required", "bottomRight");
        }
        setIsAuditPlanEditMode(false);
        setEnableAuditPlanSubmit(true);
        return;
      }
      //make api call as entry in db exists
      dispatch(UpdateAuditPlan(auditPlan2Send));
      setEnableAuditPlanSubmit(false);
      setIsAuditPlanEditMode(false);
    }

    const handleAuditPlanDelete = (record,index) => {
      /**NOTE: check column permissions if editable for user logged in
       * TODO:
       *  1. check if the record exists
       *  2. if TRUE set loading true & make api call
       *  3. if FALSE return with appropriate msg
       *  4. if api call is made and is success update with new data
       *  5. if api call failed show error message and persist old data
       */
      if(record.auditDetailId != undefined) //already exists in db cannot delete it.
        return;
      
      //NOTE: this was to prevent some bug. if any bug please take this into consideration
      // if(record.editable){
      //   showValidationWarning((<span>Click <CheckOutlined style={{ color: 'green' }} />  & then delete the row</span>), "bottomRight",)
      //   return;
      // }

      //set editable false delete the entry
      setAuditPlanForm(prevState => {
          const updatedState = [...prevState];
          updatedState[index] = { ...updatedState[index], editable: false };
          return updatedState;
        }
      )
      setAuditPlanForm((prevState) => {
        const temp = [...prevState];
        temp.splice(index, 1);
        return temp;
      });

      //NOTE:is this required
      setAuditPlanSelectedOption({
        ...auditPlanSelectedOption,
        projectScope : null,
        // store : null,  dont set this to null as it should persist for next entries also
        auditStatus : null,
        auditStartDate : null,
        auditClosureDate : null
      })
      setIsAuditPlanEditMode(false);
      let enableSubmit = false;
      for (let index = 0; index < auditPlanForm.length; index++) {
        if(auditPlanForm[index].auditDetailId == undefined && !(JSON.stringify(auditPlanForm[index]) == JSON.stringify(record))){
          enableSubmit = true;
          break;
        }
      }
      if(enableSubmit)
        setEnableAuditPlanSubmit(true)
      else 
        setEnableAuditPlanSubmit(false);
    }
    const handleAuditPlanAdd = (record) => {
      /**NOTE: check column permissions if editable for user logged in
       * TODO:
       * 1. check if he can create a new one (or projectscope exhausted)
       * 2. add a new array with empty values and push in existing formData to create new row
       * 3. new row should not contain check mark instead submit button should be used for POST api call
       * 4. if api call success update with new data
       * 5. if api call failed show error message and persist old data
       */

      //no two entries can be edited simultaneously to avoid problem in available projectScope filtering
      if(isAuditPlanEditMode) return showValidationWarning("Cannot edit 2 or more audit plan at the same time","bottomRight");
      if(record && record.auditorId)
        filterAllowedProjectScopes4AuditPlanDropDown(record.auditorId, record.auditStatus)
      //both filters should be selected
      if(!auditPlanFilter?.auditorId || !auditPlanFilter?.storeId) return showValidationWarning("Please select Auditor & Store","bottomRight");

      //if project scopes are exhausted prompt warning that no more can be added
      let currentPlanAuditorId = record?.auditorId;
      //filter out only the entries of currentAuditor
      let currentAuditorFormEntries = auditPlanForm.filter(item => item.auditorId == currentPlanAuditorId)
      let [currentSelectAuditorData] = auditPlanSelectData?.filter(item => item.auditorId == currentPlanAuditorId);
      if(currentSelectAuditorData && currentAuditorFormEntries?.length === currentSelectAuditorData?.projectScopes?.length){
        showValidationWarning("Mapped Project Scopes exhausted for this Auditor","bottomRight");
        return;
      }

      //generate empty row & set selected store
      setAuditPlanForm([
        ...auditPlanForm,
        {
          editable: true,
          auditDate: undefined,
          closureDate: undefined,
          openDocumentmapbase64: undefined,
          closureDocumentmapbase64: undefined,
          openDocument: undefined,
          closureDocument: undefined,
          projectScopeId: undefined,
          projectScopeName: undefined,
          storeId: auditPlanSelectedOption?.store?.id,
          storeName: auditPlanSelectedOption?.store?.name,
          auditStatus: undefined,
          auditStartDate: undefined,
          auditClosureDate: undefined,
          auditorId: auditPlanFilter.auditorId
        }
      ])
      setIsAuditPlanEditMode(true);
      setEnableAuditPlanSubmit(false);
    }
    const handleAuditPlanFilter = () => {
      /**
       * ALGO: file://./../../../../documentation/TPV/TpvList.md#30
       * auditorContractMapped
       */
      if(enableAuditPlanSubmit)
        setEnableAuditPlanSubmit(false);
      if(isAuditPlanEditMode)
        setIsAuditPlanEditMode(false);
      if(auditPlanFilter.storeId == undefined && auditPlanFilter.auditorId == undefined){
        setAuditPlanForm(auditPlanFormOriginal);
        setIsAuditPlanCreate(false);
        return Promise.resolve();
      }
      if(auditPlanFilter.storeId == undefined ||  auditPlanFilter.auditorId == undefined){
        //set the other one required
        setAuditPlanForm([]);
        setIsAuditPlanCreate(false);
        return Promise.resolve();
      }
      let mappedEntries = checkIfContractExistsForSelectedStore();
      if(!mappedEntries?.length){
        showValidationWarning("Store & Auditor not mapped", "bottomRight");
        if(auditPlanForm.length)setAuditPlanForm([]); //to remove data form table from previous filter
        return Promise.resolve();
      }
      else {
        let filteredData = [];
        if(auditPlanFilter?.storeId != undefined) {
          filteredData = auditPlanFormOriginal?.map((auditPlan) => {
              if(auditPlan?.storeId == auditPlanFilter.storeId)
                return auditPlan
            }).filter(item => item != undefined)
        }
        if(auditPlanFilter.auditorId != undefined) {
          filteredData = filteredData.map((auditPlan) => {
            if(auditPlan.auditorId == auditPlanFilter.auditorId)
              return auditPlan
          }).filter(item => item != undefined)
        }
        if(mappedEntries?.length && !filteredData?.length){ //if audit plan exists, + btn can be used to add
          setIsAuditPlanCreate(true);
        }
        setAuditPlanForm(filteredData);
        return Promise.resolve();
      }
    }
    const toggleAuditPlanEditable = (record, index) => {
      if(isAuditPlanEditMode) return showValidationWarning("Cannot edit 2 or more audit plan at the same time","bottomRight");
      if(record && record.auditorId)
        filterAllowedProjectScopes4AuditPlanDropDown(record.auditorId, record.auditStatus)
      // if(record?.auditStatus == 4) return showValidationWarning("Cannot Edit! Audit Completed", "bottomRight")
      auditPlanForm[index].editable = !record.editable
      setAuditPlanForm([
        ...auditPlanForm,
      ]);
      setIsAuditPlanEditMode(true);
    };
    const filterAllowedProjectScopes4AuditPlanDropDown = (auditorId, auditStatus) => {
      /**
       * ALGO:
       * 1. if auditStatus id CLOSURE AUDIT COMPLETED or its id is 4 allow all project scopes 
       * 2. 2 or more simultaneous edit not allowed
       * 3. this function should be called in following scenarios
       *    3.1 add auditplan row 
       */
      if(auditStatus == 4){
        auditPlanSelectData.map((auditDetails)=> {
          return auditDetails?.projectScopes?.map((scopes)=> {
            return {
              ...scopes,
              available: true
            }
          })
        })
        return;
      }
      auditPlanSelectData.map((auditDetails)=> {
        if(auditorId == auditDetails.auditorId){
          const formScopes = auditPlanForm.map((form) => form.projectScopeId.toString());
          return {
            ...auditDetails,
            projectScopes: auditDetails.projectScopes.map((scope) => {
              if(!formScopes.includes(scope.id)) scope.available = true;
              else scope.available = false;
              return
            })
          };
        }
      })
    }

    const handleTPVNCSearch = () => {
      /**
       * ALGO: handleTPVNCSearch file://./../../../../documentation/TPV/TpvList.md#30
       */
      setAllStore(false);
      isHandleSearchTriggeredRef.current = true;
      if(searchedItem.auditorId){
        // filterParams.splice(0,1); //remove auditoId
        dispatch(fetchNCGivenAuditorId(searchedItem.auditorId));
      }
      else {
        dispatch(doGetAllTpvNCList());
      }
    }
    const filterByDate = (ncData) => {
      const startDate = new Date(searchedItem.startDate);
      const endDate = new Date(searchedItem.endDate);

      return ncData?.filter((nc)=>{
        if(nc.auditDate && nc.closureDate){
          const auditDate = new Date(nc.auditDate);
          const closureDate = new Date(nc.closureDate);
          return auditDate >= startDate && closureDate <= endDate;
        }
        return false;
      })
    }
    const handlePostSearch = (filteredData) => {
      let NCTPVScore = [
        {
            "alertLevel": "HIGH",
            "auditorClosureUpdate": "CLOSE",
            "total": 0
        },
        {
            "alertLevel": "HIGH",
            "auditorClosureUpdate": "OPEN",
            "total": 0
        },
        {
            "alertLevel": "HIGH",
            "auditorClosureUpdate": "TOTAL",
            "total": 0
        },
        {
            "alertLevel": "MEDIUM",
            "auditorClosureUpdate": "CLOSE",
            "total": 0
        },
        {
            "alertLevel": "MEDIUM",
            "auditorClosureUpdate": "OPEN",
            "total": 0
        },
        {
            "alertLevel": "MEDIUM",
            "auditorClosureUpdate": "TOTAL",
            "total": 0
        },
        {
            "alertLevel": "LOW",
            "auditorClosureUpdate": "CLOSE",
            "total": 0
        },
        {
            "alertLevel": "LOW",
            "auditorClosureUpdate": "OPEN",
            "total": 0
        },
        {
            "alertLevel": "LOW",
            "auditorClosureUpdate": "TOTAL",
            "total": 0
        }
      ]
      let NCTPVLandLordScore = [
        {
            "alertLevel": "LANDLORD",
            "storeClosureUpdate": "CLOSE",
            "total": 0
        },
        {
            "alertLevel": "LANDLORD",
            "storeClosureUpdate": "OPEN",
            "total": 0
        },
        {
            "alertLevel": "LANDLORD",
            "storeClosureUpdate": "TOTAL",
            "total": 0
        }
      ]
      if(filteredData?.length)
      filteredData.forEach(data => {
        if(data?.auditorClosureUpdate == "OPEN"){
          switch(data?.alertLevel){
            case "HIGH": NCTPVScore[1].total +=1;
              break;
            case "MEDIUM": NCTPVScore[4].total +=1;
              break;
            case "LOW": NCTPVScore[7].total +=1;
              break;
          }
        }
        else if(data?.auditorClosureUpdate == "CLOSE"){
          switch(data?.alertLevel){
            case "HIGH": NCTPVScore[0].total +=1;
              break;
            case "MEDIUM": NCTPVScore[3].total +=1;
              break;
            case "LOW": NCTPVScore[6].total +=1;
              break;
          }
        }

        if(data?.storeClosureUpdate == "OPEN"){
          switch(data?.scope){
            case "LANDLORD": NCTPVLandLordScore[1].total +=1;
              break;
          }
        }
        else if(data?.storeClosureUpdate == "CLOSE"){
          switch(data?.scope){
            case "LANDLORD": NCTPVLandLordScore[0].total +=1;
              break;
          }
        }
      });
      NCTPVScore[2].total = NCTPVScore[1]?.total + NCTPVScore[0]?.total;
      NCTPVScore[5].total = NCTPVScore[4]?.total + NCTPVScore[3]?.total;
      NCTPVScore[8].total = NCTPVScore[7]?.total + NCTPVScore[6]?.total;

      NCTPVLandLordScore[2].total = NCTPVLandLordScore[1].total + NCTPVLandLordScore[0].total
      let [formattedNCScore, formattedLandLordNCScore] = doGetFormattedTpvNcScore(NCTPVScore, NCTPVLandLordScore);
      //set NCTPVScore
      setNCScoreTableData(formattedNCScore);
      setNCLandLordScoreTableData(formattedLandLordNCScore);
      //set viewNCDetails
      setFormattedAllNC(filteredData);
      originalFilteredNC.current = filteredData;
    }
    let filteredResult = [];
    let bfirstRecursionCompleted = false;
    let filterStatus = Array(5).fill(0);
    const filterRecursively = (filterParam, index) =>{
    if(index == filterParams.length)
        return filteredResult;
        if(searchedItem[filterParam] != null || ( Array.isArray(searchedItem[filterParam]) && searchedItem[filterParam].length)){
        for (let j = 0; j < formattedAllNC?.length; j++) {
            if(bfirstRecursionCompleted && filteredResult.length){
            filteredResult.map((ele, i)=> {
                if(((!Array.isArray(searchedItem[filterParam]) && ele[filterParam]!=searchedItem[filterParam]) || (Array.isArray(searchedItem[filterParam]) && searchedItem[filterParam].length && !searchedItem[filterParam].includes(ele[filterParam])))){
                //remove if searched item is not present for that particular parameter in already filtered Array.
                filteredResult.splice(i, 1);
                }
            })
            }
            else if(!bfirstRecursionCompleted && ((!Array.isArray(searchedItem[filterParam]) && formattedAllNC[j][filterParam].toString().includes(searchedItem[filterParam])) || (Array.isArray(searchedItem[filterParam]) && searchedItem[filterParam].length && searchedItem[filterParam].includes(formattedAllNC[j][filterParam])))){
            filterStatus[index] = 1;
            filteredResult.push(formattedAllNC[j]);
            }
        }
    }
    if(!bfirstRecursionCompleted || filteredResult.length !=0){
        if(filterStatus[index]) bfirstRecursionCompleted = true; //first iteration after filteredResult is filled 
        return filterRecursively(filterParams[index+1], index+1)
    }
    }
    const checkIfContractExistsForSelectedStore = () => {
      //return mapped entries if true else return empty array
      return auditorContractMapped.map((auditorNContractDetails)=> {
        if(auditorNContractDetails.auditorId == auditPlanFilter.auditorId){
          return auditorNContractDetails?.store?.map((store) => {
            if(store.codeId == auditPlanFilter.storeId){
              return {
                ...auditorNContractDetails
              }
            }
          })
        }
      }).flat().filter((item) => item !=undefined)
    }
    const toggleEditableNC = (id) => {
      if(isAuditPlanEditMode) return showValidationWarning("Cannot edit 2 or more non-conformity at the same time","bottomRight");
      const updatedData = formattedAllNC.map((nc) => {
        if (nc.ncDetailId === id) {
          return { ...nc, editable: !nc.editable };
        }
        return nc;
      });
      setFormattedAllNC(updatedData);
      setIsAuditPlanEditMode(true);
    }
    const handleUpdateNC = (ele, index) => {
      console.log(ele);
      console.log(formattedAllNC)
      let data2Update  = {
        ...ele,
        auditorClosureComment: tpvNCForm?.auditorClosureComment != undefined ? tpvNCForm?.auditorClosureComment: ele.auditorClosureComment,
        auditorClosureUpdate: tpvNCForm?.ncClosureUpdateMap != undefined ? tpvNCForm?.ncClosureUpdateMap: ele.auditorClosureUpdate
      }
      //remove unwanted
      delete data2Update.editable;
      delete data2Update.projectScopeName;
      delete data2Update.storeName;
      formattedAllNC[index]["editable"] = !formattedAllNC[index]["editable"];
      const copyOfOriginal = [...formattedAllNC];
      setFormattedAllNC([
        ...formattedAllNC
      ])
      setTpvNCForm([]);
      //call api
      dispatch(UpdateTpvNC([data2Update], copyOfOriginal));
    }
    const showValidationWarning = (msg, placement) => {
      notification.open({
        message: 'Warning',
        description: msg,
        placement: placement,
      });
    };

    const _doSubmitTpvAudit = (projectScopeId) => {
      if(!ncExcel){
        showValidationWarning("Upload NC Excel", "bottomRight")
        return;
      }
      if(!auditPlanFilter.auditorId){
        showValidationWarning("Select Auditor", "bottomRight")
        return;
      }
      if(!auditPlanFilter.storeId){
        showValidationWarning("Select Store", "bottomRight")
        return;
      }
      if(projectScopeId == undefined){
        showValidationWarning("Project Scope missing", "bottomRight")
        return;
      }

      let formData = new FormData();
      // Append the XLSX file to the FormData object
      formData.append('file', ncExcel);
      const storeNCity = auditPlanSelectData.map((item) => {
          return item?.store?.map((store)=> {
            if (item.auditorId === auditPlanFilter?.auditorId && store.codeId == auditPlanFilter?.storeId) {
              return {
                state: Number(store?.state),
                city: Number(store?.city),
              };
            }
          }).filter((item)=> item !=undefined)
      }).filter((item) => item.length > 0).flat();
      console.log(storeNCity);
      formData.append('storeId', auditPlanFilter?.storeId);
      formData.append('stateId', storeNCity[0]["state"]);
      formData.append('cityId', storeNCity[0]["city"]);
      formData.append('auditorId', auditPlanFilter?.auditorId);
      formData.append('projectScopeId', projectScopeId);
      dispatch(CreateTpvNC(formData))
    }

    const handleNcStatusChange = (status, index) => {
      if(status==="select-all") {
        const updatedItems = formattedAllNC.map((item) =>{
          copyFormattedAllNC.forEach((ele)=> {
            if(ele.ncDetailId == item.ncDetailId) ele.auditorClosureUpdate = !selectAllNC?"CLOSE":"OPEN";
          })
          return {
            ...item,
            auditorClosureUpdate: !selectAllNC?"CLOSE":"OPEN"
          }
        });
        setFormattedAllNC(updatedItems);
        setSelectAllNC(!selectAllNC);
      }
      if(index>= 0){
        //alter index accroding to current page & page size
        index = NCPageState.pageSize*(NCPageState.currentPage-1)+ index
        setFormattedAllNC((prevState)=> {
          const updatedState = [...prevState]
          updatedState[index].auditorClosureUpdate = !status?"CLOSE":"OPEN";
          copyFormattedAllNC.forEach((ele)=> {
            if(updatedState[index].ncDetailId == ele.ncDetailId) ele.auditorClosureUpdate = !status?"CLOSE":"OPEN";
          })
          return updatedState;
        })
      }
    }

    const filterNCViewOnStatus = (status) => {
      if(status=="ALL"){
        setFormattedAllNC(copyFormattedAllNC); //copyFormattedAllNC should have data before opening the modal
        return;
      }
      const filteredData = copyFormattedAllNC.filter((nc)=> {
        return nc.auditorClosureUpdate == status
      })
      setFormattedAllNC(filteredData);
    }

    const viewDocumentInModal = (record, index, title, fileType)=> {
      let doc;
      if(title =="Open Document"){
        if(!record.openDocument) return showValidationWarning("Open Document is not updated","bottomRight")
        doc = record.openDocument;
      }
      if(title =="Close Document"){
        if(!record.closureDocument) return showValidationWarning("Close Document is not updated","bottomRight")
        doc = record.closureDocument;
      } 
      if(title == "Open Image"){
        if(!record.openImage) return showValidationWarning("Open Image is not updated","bottomRight")
        doc = record.openImage;
      }
      const fileUrl = `${apiInterface}/downloadfiles?Image_id=${doc}&token_id=${Cookie.get('token')}`
      handleExport(ApiGateWay.BlobUrlGet, fileUrl, fileType, title)
    }
    //table for audit plan
    const AuditPlanTableColumns = [
        {
          title: 'SL No.',
          dataIndex: 'slNo',
          width:100,
          render: (text, record, index) => {
            return index + 1; // Adding 1 to index to start from 1 instead of 0
          },
        },
        {
          title: 'Store Name',
          dataIndex: 'storeName',
          key: 'storeName',
          width:200,
          render: (text, record, index) => {
            return (
              text !=undefined?(<span>{text}</span>):
              <span>{auditPlanSelectedOption?.store?.name}</span>
              )
          }
        },
        {
          title: 'Auditor Name',
          dataIndex: 'auditorName',
          key: 'auditorName',
          width:200,
          render: (text, record, index) => {
            return (
              text !=undefined?(<span>{text}</span>):
              <span>
                {
                  auditPlanSelectData?.map((auditPlan4Select => 
                    (auditPlan4Select.auditorId === record.auditorId) &&
                    <span key={auditPlan4Select.auditorId} value={auditPlan4Select.auditorId}>
                      {auditPlan4Select.auditorName}
                    </span>
                  ))
                }
            </span>
            )
          }
        },
        {
          title: 'Project Scopes',
          dataIndex: 'projectScopeName',
          key: 'projectScopeName',
          width:200,
          render: (text, record, index) => {
            return (
              !isUserAuditor  && record.editable ? (
                <Select className="form-control"
                        showSearch
                        onSelect={(value, option) => {
                          setAuditPlanSelectedOption({...auditPlanSelectedOption,
                            projectScope: {
                              id: value,
                              name: option.children
                            }
                          })
                        }}
                        onChange={(value) => {
                          setSearchedItem({...searchedItem,projectScopeName:value})
                        }}
                        placeholder={record?.projectScopeName}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                        }
                        value={auditPlanForm.projectScopeName} //formData
                      >{
                        auditPlanSelectData?.map((auditPlan4Select)=> {
                          if(auditPlan4Select.auditorId === record.auditorId)
                          return auditPlan4Select?.projectScopes.map((item =>
                            item.available && <Option key={item.id} value={item.id}>{item.value}</Option>
                            ))
                          })
                        }
                </Select>
              ) : (
                <span onClick={() => toggleAuditPlanEditable(record, index)}>{text}</span>
              )
            );
          }
        },
        {
            title: "Audit Start Date",
            width:200,
            dataIndex: "auditStartDate",
            key: "auditStartDate",
            render: (text, record, index) => {
              return (
                record.editable ? (
                  <DatePicker className="form-control" placeholder={record?.auditStartDate}  format={'YYYY-MM-DD'} onChange={(date, dateString) => setAuditPlanSelectedOption({...auditPlanSelectedOption, auditStartDate: dateString})} />
                ) : (
                  <span onClick={() => toggleAuditPlanEditable(record, index)}>{text}</span>
                )
              );
            }
        },
        {
            title: "Audit Closure Date",
            width:200,
            dataIndex: "auditClosureDate",
            key: "auditClosureDate",
            render: (text, record, index) => {
              return (
                record.editable ? (
                  <DatePicker className="form-control" placeholder={record?.auditClosureDate}  format={'YYYY-MM-DD'} onChange={(date, dateString) => setAuditPlanSelectedOption({...auditPlanSelectedOption, auditClosureDate: dateString})} />
                ) : (
                  <span onClick={() => toggleAuditPlanEditable(record, index)}>{text}</span>
                )
              );
            }
        },
        {
          title: 'Audit Status',
          dataIndex: 'auditStatus',
          key: 'auditStatus',
          width:200,
          render: (text, record, index) => {
            return (
              record.editable ? (
                <Select className="form-control"
                        showSearch
                        onSelect={(value, option) => {
                          setAuditPlanSelectedOption({...auditPlanSelectedOption,
                            auditStatus : {
                              id: value,
                              name: option.children
                            }
                          })
                        }}
                        onChange={(value) => {
                          setSearchedItem({...searchedItem,projectScope:value})
                        }}
                        // disabled={record?.auditStatus == 4}
                        placeholder={AuditStatus.filter((status) => record?.auditStatus == status.id)[0]?.status}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                        }
                        value={searchedItem.auditStatus}
                      >{
                          AuditStatus.map((auditStatus)=>
                            <Option key={auditStatus.id} value={auditStatus.id}>{auditStatus.status}</Option>
                          )
                        }
                </Select>
              ) : (
                  AuditStatus.map((auditStatus)=>
                   auditStatus.id == text ? <span onClick={() => toggleAuditPlanEditable(record, index)}>{auditStatus.status}</span>:null
                  )
              )
            );
          }
        },
        {
          title: 'Audit Open Document',
          dataIndex: 'openDocument',
          key: 'openDocument',
          width:50,
          render: (text, record, index) => {
            return (
              isUserAuditor && record.editable ? (
                  <input type="file" className="form-control" accept={".pdf"} onChange={(e) => setSelectedStoreFile(e.target.files[0], "OPEN",index)}/>
              ) : (
                <Tooltip title="Open Document">
                  <EyeOutlined style={{ fontSize: '16px', color: 'red' }} onClick={() => viewDocumentInModal(record, index, "Open Document", "pdf")}/>
                </Tooltip>
              )
            );
          }
        },
        {
          title: 'Audit Closure Document',
          dataIndex: 'closureDocument',
          key: 'closureDocument',
          width:50,
          render: (text, record, index) => {
            return (
              isUserAuditor && record.editable ? (
                  <input type="file" className="form-control" accept={".pdf"} onChange={(e) => setSelectedStoreFile(e.target.files[0], "close",index)}/>
              ) : (
                <Tooltip title="Closure Document">
                  <EyeOutlined style={{ fontSize: '16px', color: 'green' }} onClick={() => viewDocumentInModal(record, index, "Close Document", "pdf")}/>
                </Tooltip>
              )
            );
          }
        }
    ]

    if(isUserAuditor) AuditPlanTableColumns.push(
      {
        title: 'Upload NC',
        dataIndex: 'uploadNC',
        key: 'uploadNC',
        width:200,
        render: (text, record, index) => {
          return (
            record.auditDetailId !== undefined &&
            <input type="file" className="form-control" accept=".xlsx" onChange={(e) => setNCExcel(e.target.files[0])}/>
          )
        }
      }
    )

    //should be at last so pushing here
    AuditPlanTableColumns.push(
      {
        title: 'Actions',
        fixed: 'right',
        width: 120,
        render: (text, record, index) => (
          <div>
            {record.editable && <IconButton
                title='Update'
                onClick={() => handleAuditPlanUpdate(record, index)}
                style={{ color: ' #a94442' }}
              >
                <CheckOutlined style={{ color: 'green' }} />
            </IconButton>}
            { record.auditDetailId == undefined&&
              <IconButton
              title='Delete'
              onClick={() => handleAuditPlanDelete(record,index)}
              style={{ color: ' #a94442' }}
              >
                <DeleteOutlined />
              </IconButton>
            }
            {(auditPlanForm.length == index+1)&&<IconButton
                
                title='Add New'
                onClick={() => handleAuditPlanAdd(record)}
                style={{ color: ' #a94442' }}
              >
                <PlusOutlined />
            </IconButton>}
            { isUserAuditor &&  record.auditDetailId !== undefined &&
            <IconButton
                title='Upload NC'
                style={{ color: ' #a94442' }}
                accept=".xlsx"
                onClick={() => _doSubmitTpvAudit(record.projectScopeId)}
              >
                <UploadOutlined/>
            </IconButton>
            }
          </div>
        ),
      },
    )

    //Table for stats wrt alert & sope under landlord
    const NCScoreTableColumns = [
      {
        key: "stats_first_column",
        dataIndex: "stats_first_column",
        width: 100
      },
      {
        title: "High",
        width: 100,
        dataIndex: "alert_high",
        key: "alert_high",
        onCell: (_, rowIndex) => ({
          onClick: () => viewNCDetails(rowIndex, 0, 'alert'),
        }),
        render(text, record, index) {
          return {
            props: {
              style: { background: index ==1? NCScoreCellColor.close_high: NCScoreCellColor.open_high }
            },
            children: <div>{text}{index==3?'%':''}</div>
          };
        }
      },
      {
        title: "Medium",
        width: 100,
        dataIndex: "alert_medium",
        key: "alert_medium",
        onCell: (_, rowIndex) => ({
          onClick: () => viewNCDetails(rowIndex, 1, 'alert'),
        }),
        render(text, record, index) {
          return {
            props: {
              style: { background: index ==1? NCScoreCellColor.close_medium: NCScoreCellColor.open_medium }
            },
            children: <div>{text}{index==3?'%':''}</div>
          };
        }
      },
      {
        title: "Low",
        width: 100,
        dataIndex: "alert_low",
        key: "alert_low",
        onCell: (_, rowIndex) => ({
          onClick: () => viewNCDetails(rowIndex, 2, 'alert'),
        }),
        render(text, record, index) {
          return {
            props: {
              style: { background: index ==1? NCScoreCellColor.close_low: NCScoreCellColor.open_low }
            },
            children: <div>{text}{index==3?'%':''}</div>
          };
        }
      },
    ]
    const LandlordStatsTableCol = [
      {
        key: "landlord_first_column",
        dataIndex: "landlord_first_column",
        width: 100
      },
      {
        title: "Landlord",
        dataIndex: "land_lord",
        key: "land_lord",
        width: 100,
        onCell: (_, rowIndex) => ({
          onClick: () => viewNCDetails(rowIndex, 0, "LANDLORD"),
        }),
        render(text, record, index) {
          return {
            props: {
              style: { background: index ==1? NCScoreCellColor.landlord_closed: NCScoreCellColor.landlord_open }
            },
            children: <div>{text}{index==3?'%':''}</div>
          };
        }
      }
    ]

    //view NC Table
    const NCTableColumns = [
      {
        title: 'SL No.',
        dataIndex: 'slNo',
        width:100,
        render: (text, record, index) => {
          return index + 1; // Adding 1 to index to start from 1 instead of 0
        },
      },
      {
        title: 'Store Name',
        dataIndex: 'storeName',
        key: 'storeName',
        width:100,
      },
      {
        title: 'Auditor Name',
        dataIndex: 'auditorName',
        key: 'auditorName',
        width:100,
      },
      {
        title: 'Project Scopes',
        dataIndex: 'projectScopeName',
        key: 'projectScopeName',
        width:100,
      },
      {
        title: 'Alert Level',
        dataIndex: 'alertLevel',
        key: 'alertLevel',
        width:200,
        render: (text, record, index) => {
          return {
            props: {
              style: { background: NCScoreCellColor[ record.auditorClosureUpdate?.toLowerCase()+"_"+record.alertLevel?.toLowerCase()]}
            },
            children: <div>{text}</div>
          }
        }
      },
      {
        title: 'Alert Point',
        dataIndex: 'alertPoint',
        key: 'alertPoint',
        width:200,
        render: (text, record, index) => {
          return (
              <span>{text}</span>
          );
        }
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        width:200,
      },
      {
        title: 'Solution',
        dataIndex: 'solution',
        key: 'solution',
        width:200,
      },
      {
        title:
            <div className='text-center' style={{display:"flex", justifyContent: "space-around", flexDirection: "column" }}>
              <div>Auditor Closure Update</div>
              <div style={{display:"flex", justifyContent: "space-around"}}>
                <Tooltip title="All">
                  <EyeOutlined style={{ fontSize: '20px', color: 'white' }} onClick={() => filterNCViewOnStatus("ALL")}></EyeOutlined>
                </Tooltip>
                <Tooltip title="OPEN">
                <EyeOutlined style={{ fontSize: '20px', color: 'red' }} onClick={() => filterNCViewOnStatus("OPEN")}></EyeOutlined>
                </Tooltip>
                <Tooltip title="CLOSE">
                  <EyeInvisibleOutlined style={{ fontSize: '20px', color: 'green' }} onClick={() => filterNCViewOnStatus("CLOSE")}></EyeInvisibleOutlined>
                </Tooltip>
              </div>
            </div>,
        dataIndex: 'auditorClosureUpdate',
        key: 'auditorClosureUpdate',
        width:200,
        render: (text, record, index) => {
          return (
            record.editable ? (
              <Select className="form-control"
                      showSearch
                      onSelect={(value, option) => {
                        setTpvNCForm({...tpvNCForm,
                          ncClosureUpdateMap: value
                        })
                      }}
                      onChange={(value) => {
                        setSearchedItem({...searchedItem,ncClosureUpdateMap:value})
                      }}
                      // disabled={record?.auditorClosureUpdate == "CLOSE"}
                      defaultValue={record?.auditorClosureUpdate == "CLOSE"?"CLOSE":"OPEN"}
                      placeholder="-- Please Select --"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                      }
                      value={searchedItem.ncClosureUpdateMap}
                    >{
                      ncClosureUpdateMap.map((item)=>
                          <Option key={item} value={item}>{item}</Option>
                        )
                      }
              </Select>
            ) : (
              <span onClick={() => isUserAuditor && toggleEditableNC(record.ncDetailId)}>{text}</span>
            )
          );
        }
      },
      {
        title: 'Auditor Closure Comment',
        dataIndex: 'auditorClosureComment',
        key: 'auditorClosureComment',
        width:200,
        render: (text, record, index) => {
          return (
            record.editable ? (
              <input type="text" className="form-control" onChange={(e) => setTpvNCForm({...tpvNCForm, auditorClosureComment: e.target.value})}/>
            ) : (
              <span onClick={() => isUserAuditor && toggleEditableNC(record.ncDetailId)}>{text}</span>
            )
          );
        }
      },
      {
        title: <div style={{display:"flex", justifyContent: "space-between" }}>
                <div>Actions</div>
                <div style={{ whiteSpace: "pre" }}>
                  <>Select All  </>
                  <Checkbox disabled={!isUserAuditor} checked={selectAllNC} onClick={() => handleNcStatusChange("select-all", -1)}></Checkbox>
                </div>
              </div>,
        fixed: 'right',
        width: 150,
        render: (text, record, index) => (
          <div style={{ display:'flex', justifyContent: "space-between"}}>
            {record.editable && <IconButton
                title='Update'
                onClick={() => handleUpdateNC(record, index)}
                style={{ color: ' #a94442' }}
              >
                <CheckOutlined style={{ color: 'green' }} />
            </IconButton>}
            <IconButton>
                <Tooltip title="Open Image">
                  <EyeOutlined style={{ fontSize: '16px', color: 'red' }} onClick={() => viewDocumentInModal(record, index, "Open Image", "jpg")}/>
                </Tooltip>
            </IconButton>
            <IconButton
                title='Status'
                style={{ color: ' #a94442' }}
              >
                <Checkbox disabled={!isUserAuditor} checked={record?.auditorClosureUpdate =="CLOSE"?true:false} onClick={() => handleNcStatusChange(record?.auditorClosureUpdate =="CLOSE"?true:false, index)} />
            </IconButton>
          </div>
        ),

      },
    ]
    const viewNCDetails = (rowIndex, columnIndex, type) =>{
      setNCTableLoading(true);
      if(searchedItem?.auditorId || searchedItem?.stateId || searchedItem?.cityId || searchedItem?.storeId?.length || searchedItem?.projectScopeId?.length || searchedItem?.startDate || searchedItem?.endDate){
        filterAppliedNC(rowIndex, columnIndex, type)
        return;
      }
      console.log(rowIndex, columnIndex, type);
      if(rowIndex === 3) return; //completion % row & total
      /**
       * ALGO: file://./../../../../documentation/TPV/TpvList.md#3
       * rowIndex represents alertType
       * columnIndex represents alertLevel
       */
      if(type === 'alert'){
        //clicks on table
        let cellInfo = rowIndex.toString() + columnIndex.toString();
        let alertLevel = null;
        let alertType = null;
        switch(cellInfo){
          case '00': alertType = "OPEN"; alertLevel = "HIGH"; break;
          case '01': alertType = "OPEN"; alertLevel = "MEDIUM"; break;
          case '02': alertType = "OPEN"; alertLevel = "LOW"; break;
          case '10': alertType = "CLOSE"; alertLevel = "HIGH"; break;
          case '11': alertType = "CLOSE"; alertLevel = "MEDIUM"; break;
          case '12': alertType = "CLOSE"; alertLevel = "LOW"; break;
          case '20': alertType = "TOTAL"; alertLevel = "HIGH"; break;
          case '21': alertType = "TOTAL"; alertLevel = "MEDIUM"; break;
          case '22': alertType = "TOTAL"; alertLevel = "LOW"; break;
        }
        setFormattedAllNC([]);
        _doOpenNCModal();
        //makeApi call
        if(alertLevel && alertType){
          doGetTpvNCDetailsGivenParams(alertType, alertLevel)
          .then((response)=> {
            console.log(response);
            //format response
            let formmatedResponse = getFormattedAllNcList(response?.tpvncDetailInfos)
            setFormattedAllNC(formmatedResponse)
            setCopyFormattedAllNC(formmatedResponse)
            setNCTableLoading(false);
          })
          .catch((err)=> {
            console.log(err);
          })
        }
      }else if(type === "LANDLORD"){
        let cellInfo = rowIndex.toString() + columnIndex.toString();
        let alertLevel = null;
        let alertType = null;
        switch(cellInfo){
          case '00': alertType = "OPEN"; alertLevel = "LANDLORD"; break;
          case '10': alertType = "CLOSE"; alertLevel = "LANDLORD"; break;
          case '20': alertType = "TOTAL"; alertLevel = "LANDLORD"; break;
        }
        setFormattedAllNC([]);
        _doOpenNCModal();
        //makeApi call
        if(alertLevel && alertType){
          doGetTpvNCDetailsGivenParams(alertType, alertLevel)
          .then((response)=> {
            console.log(response);
            //format response
            let formmatedResponse = getFormattedAllNcList(response?.tpvncDetailInfos)
            if(searchedItem.auditorId && (Array.isArray(searchedItem.projectScopeId) && searchedItem.projectScopeId.length) && (Array.isArray(searchedItem.state) && searchedItem.state.length) && (Array.isArray(searchedItem.city) && searchedItem.city.length) && searchedItem?.storeId?.length && searchedItem.startDate && searchedItem.endDate){
                //handleTPVNCSearch
            }
            setFormattedAllNC(formmatedResponse)
            setCopyFormattedAllNC(formmatedResponse)
            setNCTableLoading(false);
          })
          .catch((err)=> {
            console.log(err);
          })
        }
      }else {
        //clicks on button
        dispatch(doGetAllTpvNCList());
        _doOpenNCModal();
        setNCTableLoading(false);
      }
    }

    const filterAppliedNC = (rowIndex, columnIndex, type)=> {
      let alertLevel = null;
      let alertType = null;
      let copyFilteredNC=null;
      let cellInfo = rowIndex?.toString() + columnIndex?.toString();
      if(originalFilteredNC.current == null || originalFilteredNC.current?.length == 0){
        copyFilteredNC = [];
      }else if(type == 'all_nc_list'){
        copyFilteredNC = originalFilteredNC.current
      }else if(type === 'alert'){
        //clicks on table
        switch(cellInfo){
          case '00': alertType = "OPEN"; alertLevel = "HIGH"; break;
          case '01': alertType = "OPEN"; alertLevel = "MEDIUM"; break;
          case '02': alertType = "OPEN"; alertLevel = "LOW"; break;
          case '10': alertType = "CLOSE"; alertLevel = "HIGH"; break;
          case '11': alertType = "CLOSE"; alertLevel = "MEDIUM"; break;
          case '12': alertType = "CLOSE"; alertLevel = "LOW"; break;
          case '20': alertType = "TOTAL"; alertLevel = "HIGH"; break;
          case '21': alertType = "TOTAL"; alertLevel = "MEDIUM"; break;
          case '22': alertType = "TOTAL"; alertLevel = "LOW"; break;
        }
      }else if(type === "LANDLORD"){
        switch(cellInfo){
          case '00': alertType = "OPEN"; alertLevel = "LANDLORD"; break;
          case '10': alertType = "CLOSE"; alertLevel = "LANDLORD"; break;
          case '20': alertType = "TOTAL"; alertLevel = "LANDLORD"; break;
        }
      }
      if(alertLevel && alertType){
        if(alertLevel == "LANDLORD"){
          copyFilteredNC = originalFilteredNC.current?.filter((nc) => nc?.scope == "LANDLORD" && nc?.storeClosureUpdate == alertType);
          if(alertType == "TOTAL"){
            copyFilteredNC = [
              ...originalFilteredNC.current?.filter((nc) => nc?.scope == "LANDLORD" && (nc?.storeClosureUpdate == "OPEN")),
              ...originalFilteredNC.current?.filter((nc) => nc?.scope == "LANDLORD" && nc?.storeClosureUpdate == "CLOSE")

            ]
          }
        } else if(alertLevel == "HIGH"){
          copyFilteredNC = originalFilteredNC.current?.filter((nc) =>(nc?.alertLevel == alertLevel) && (nc?.auditorClosureUpdate == alertType));
          if(alertType == "TOTAL"){
            copyFilteredNC = [
              ...originalFilteredNC.current?.filter((nc) => nc?.alertLevel == alertLevel && (nc?.auditorClosureUpdate == "OPEN")),
              ...originalFilteredNC.current?.filter((nc) => nc?.alertLevel == alertLevel && nc?.auditorClosureUpdate == "CLOSE")

            ]
          }
        }
        else if(alertLevel == "MEDIUM"){
          copyFilteredNC = originalFilteredNC.current?.filter((nc) => (nc?.alertLevel == alertLevel) && (nc?.auditorClosureUpdate == alertType));
          if(alertType == "TOTAL"){
            copyFilteredNC = [
              ...originalFilteredNC.current?.filter((nc) => nc?.alertLevel == alertLevel && (nc?.auditorClosureUpdate == "OPEN")),
              ...originalFilteredNC.current?.filter((nc) => nc?.alertLevel == alertLevel && nc?.auditorClosureUpdate == "CLOSE")

            ]
          }
        }
        else if(alertLevel == "LOW"){
          copyFilteredNC = originalFilteredNC.current?.filter((nc) => (nc?.alertLevel == alertLevel) && (nc?.auditorClosureUpdate == alertType));
          if(alertType == "TOTAL"){
            copyFilteredNC = [
              ...originalFilteredNC.current?.filter((nc) => nc?.alertLevel == alertLevel && (nc?.auditorClosureUpdate == "OPEN")),
              ...originalFilteredNC.current?.filter((nc) => nc?.alertLevel == alertLevel && nc?.auditorClosureUpdate == "CLOSE")

            ]
          }
        }
      }
      if(copyFilteredNC !=null)
      _doOpenNCModal();
      setFormattedAllNC(copyFilteredNC);
      setCopyFormattedAllNC(copyFilteredNC); //is there alternative to this?
      setNCTableLoading(false);
    }

    const setSelectedStoreFile = (file, type, index) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      if(type == "OPEN"){
        reader.onload = () => {
          let base64 = reader.result.toString().replace(/^data:(.*,)?/, '').trim();
          auditPlanForm[index]["openDocument"] = file.name
          auditPlanForm[index]["openDocumentmapbase64"] = base64;
          setAuditPlanForm([
            ...auditPlanForm,
          ])
        }
      }
      if(type == "close"){
        reader.onload = () => {
          let base64 = reader.result.toString().replace(/^data:(.*,)?/, '').trim();
          auditPlanForm[index]["closureDocument"] = file.name
          auditPlanForm[index]["closureDocumentmapbase64"] = base64;
          setAuditPlanForm([
            ...auditPlanForm,
          ])
        }
      }
      reader.onerror = error => console.log(error)
    }
    const setPrequisite4AuditPlan = () => { // when create audit plan btn clicked
      if(!isAuditPlanCreate)
        return;
      //Validation
      let doesContractMappingExists4Auditor = auditPlanSelectData.filter((plan)=> {
        return plan.auditorId == auditPlanFilter.auditorId
      })
      if(!doesContractMappingExists4Auditor.length){
        showValidationWarning("Selected Auditor does not have Contract Mapping", "bottomRight");
        return;
      }
      let doesContractMappingExists4StoreNAuditor = doesContractMappingExists4Auditor.filter((auditPlan4Select)=> {
          const matchingStores = auditPlan4Select?.store?.filter((store)=> {
            return auditPlanFilter.storeId == store.codeId;
          })
          return matchingStores.length > 0;
      })
      if(!doesContractMappingExists4StoreNAuditor.length){
        showValidationWarning("Selected Auditor & Store are not Mapped", "bottomRight");
        return;
      }
      //generate empty row & set selected store
      setAuditPlanForm([
        {
          editable: true,
          auditDate: undefined,
          closureDate: undefined,
          openDocumentmapbase64: undefined,
          closureDocumentmapbase64: undefined,
          openDocument: undefined,
          closureDocument: undefined,
          projectScopeId: undefined,
          projectScopeName: undefined,
          storeId: auditPlanFilter.storeId,
          storeName: undefined,
          auditStatus: undefined,
          auditStartDate: undefined,
          auditClosureDate: undefined,
          auditorId: auditPlanFilter.auditorId
        }
      ])
    }
    const dataHandler = (value)=>{
      setAllStore(value[0]==="selectAll"?true:false);
    }
    return (
        <>
          <PrintModal
            openModal={showPrintModal} // Pass the modal visibility state
            closeModal={closeModal} // Pass the function to close the modal
            modalLoading={printLoading} // You can adjust this based on loading status
            fileURL={printFileURL}
            modalTitle={modalTitle}
          />
        {status.modalOpen && !status?.loading ? (
          <MessageBox
            message={status.message}
            onClose={() => {
              dispatch(AuditPlanList(true));
              dispatch(doGetAllTpvAuditListnNCScore());
              // dispatch(doGetAllTpvNCList());
              if(status?.formattedNUpdateNC && status?.formattedNUpdateNC != null){
                const updatedNcData = formattedAllNC?.map((nc)=>{
                  const updatedValue = status.formattedNUpdateNC.find(
                    (updatedNc) => nc?.ncDetailId === updatedNc?.ncDetailId
                  );
                
                  return updatedValue || nc;
                })
                setFormattedAllNC([
                  ...updatedNcData
                ])
              }
            }
            }
          />
        ) : null}
        {/**status?.isAuditorList*/ true? <div>
          <Header title={title} />
          <Menu />
          <Modal
            open={NCModalVisible} title="NC List" width={1000}
            footer={[
              <button type='button' onClick={_doSubmitTpvNC} className='btn muted-button  deca-btn-orange'>Submit</button>,
              <button type='button' onClick={_doCloseNCModal} className='btn muted-button  deca-btn-orange'>Close</button>
            ]}
          >
            <div className="m-table__main">
              <div className="m-table__responsive large-width">
                <Table columns={NCTableColumns} dataSource={formattedAllNC} loading={NCTableLoading} pagination={ncPagination}/>
              </div>
            </div>
          </Modal>
          <div className='content-wrapper'>
            {status?.loading ? (
              <Spinner message="DO NOT close this window while its Processing"/>
            ) : (
              <div>
                <div className='content'>
                  <div id="tpvFilter" className="m-panel mt-10">
                    <div className="m-panel__body p10">
                      <div className="row">
                      <div className="col-md-2">
                          <div className='form-group'>
                            <label htmlFor='exampleInput'>Auditor</label>
                            <Select className="form-control"
                              showSearch
                              allowClear={true}
                              onChange={(value) => {
                                setSearchedItem({...searchedItem,auditorId:value})
                              }}
                              placeholder="-- Please Select --"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                              }
                              value={searchedItem.auditorId}
                            >{
                                tpvList?.AuditorList.map(((item,index) =>
                                  <Option key={index} value={item.id}>{item.auditorName}</Option>
                                ))
                              }
                            </Select>
                          </div>
                        </div>
                        <div className="col-md-2">
                            <div className='form-group'>
                              <label htmlFor='exampleInput'>Select state</label>
                              <div className="">
                                <Select className="form-control"
                                  showSearch
                                  mode="multiple"
                                  onChange={(value) => {
                                    setSearchedItem({...searchedItem,stateId:value})
                                  }}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                                  }
                                  value={searchedItem.stateId}
                                >{
                                    tpvList?.StateList?.map((item =>
                                      <Option key={item.codeId} value={item.codeId}>{item.codeValue}</Option>
                                    ))
                                  }
                                </Select>
                              </div>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className='form-group'>
                              <label htmlFor='exampleInput'>Select city</label>
                              <div className="">
                                <Select className="form-control"
                                  showSearch
                                  mode="multiple"
                                  onChange={(value) => {
                                    setSearchedItem({...searchedItem,cityId:value})
                                  }}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                                  }
                                  value={searchedItem.cityId}
                                >{
                                    tpvList?.CityList.map((item =>
                                      <Option key={item.codeId} value={item.codeId}>{item.codeValue}</Option>
                                    ))
                                  }
                                </Select>
                              </div>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className='form-group'>
                              <label htmlFor='exampleInput'>Store</label>
                              <Select className="form-control"
                                allowClear={true}
                                onChange={(value) => {
                                  dataHandler(value);
                                  value = value[0]==="selectAll"?
                                  value=tpvList?.StoreList.map((item) => item.storeId):value;
                                  setSearchedItem({...searchedItem,storeId:value});
                                }}
                                showSearch
                                mode='multiple' 
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children?.toLowerCase()
                                  .indexOf(input?.toLowerCase()) >= 0
                                }
                                value={searchedItem.storeId}
                              >
                                 {/* Add a "Select All" option */}
                                 {<Option key="selectAll">
                                 {selectAllStore ?"All stores are selected" : "Select All"}
                                  </Option>}
                                {
                                  tpvList?.StoreList.map((item,index) => (
                                    selectAllStore ?
                                    <Option disabled={item.storeName} key={index} value={item.storeId} >{item.storeName}</Option> : 
                                    <Option key={index} value={item.storeId}>{item.storeName}</Option> 

                                  ))
                                }
                              
                              </Select>
                            </div>
                        </div>
                        <div className="col-md-2">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Start Date</label>
                          <DatePicker className="form-control"  format={'YYYY-MM-DD'} value={searchedItem.startDate? dayjs(searchedItem.startDate):null}  onChange={(date, dateString) => setSearchedItem({ ...searchedItem, startDate: dateString })} />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>End Date</label>
                          <DatePicker className="form-control"  format={'YYYY-MM-DD'} value={searchedItem.endDate?dayjs(searchedItem.endDate):null} onChange={(date, dateString) => setSearchedItem({  ...searchedItem, endDate: dateString })} />
                        </div>
                      </div>
                      </div>
                      <div className='row'>
                        <div className="col-md-2">
                          <div className='form-group'>
                            <label htmlFor='exampleInput'>Select Project Scope</label>
                            <Select className="form-control"
                              showSearch
                              mode="multiple"
                              onChange={(value) => {
                                setSearchedItem({...searchedItem,projectScopeId:value})
                              }}
                              placeholder="-- Please Select --"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                              }
                              value={searchedItem.projectScopeId}
                            >{
                                tpvList?.ProjectScopes.map((item =>
                                  <Option key={item.id} value={item.id}>{item.name}</Option>
                                ))
                              }
                            </Select>
                          </div>
                        </div>
                        <div className="col-md-1 btn-no-lbl">
                            <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow' onClick={handleTPVNCSearch}>
                              <i className="fa fa-search"></i>
                            </button>
                        </div>
                        { !isUserAuditor &&
                          <div className="col-md-9 text-right btn-no-lbl">
                          
                               <Link to="/previewTpvReport" state={{ 
                                searchedItem: searchedItem,
                                NCScoreLoading,
                                  NCScoreTableData,
                                  NCLandLordScoreTableData,
                                  tpvList
                              }} >

                              <button
                                  className='deca-btn-yellow'
                                  style={{
                                    marginRight: '10px',
                                  }}
                                >
                                  Download PDF Report
                              </button>
                           </Link>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  {
                      <TpvScoreBoard NCScoreCellColor={NCScoreCellColor} NCScoreTableColumns={NCScoreTableColumns} NCScoreLoading={NCScoreLoading} NCScoreTableData={NCScoreTableData} LandlordStatsTableCol={LandlordStatsTableCol} NCLandLordScoreTableData={NCLandLordScoreTableData}/>
                  }
                  <div className="m-panel">
                    <div className="m-panel__body p10">
                      <div className='row'>
                          <div className="col-md-2">
                              <div className='form-group'>
                                <Select className="form-control"
                                  showSearch
                                  allowClear={true}
                                  disabled={isAuditPlanEditMode}
                                  onChange={(value) => {
                                    // setSearchedItem({...searchedItem,storeId:value})
                                    setAuditPlanFilter({...auditPlanFilter, storeId: value});
                                  }}
                                  onSelect={(value, option)=> {
                                    //auto populate the select for
                                    setAuditPlanSelectedOption({...auditPlanSelectedOption,
                                      store: {
                                        id: value,
                                        name: option.children
                                      }
                                    })
                                  }}
                                  placeholder="-- Select Store --"
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                                  }
                                  value={auditPlanFilter.storeId}
                                >{
                                    tpvList?.StoreList.map(((item) =>
                                      <Option key={item.storeId} value={item.storeId}>{item.storeName}</Option>
                                    ))
                                  }
                                </Select>
                              </div>
                          </div>
                          <div className="col-md-2">
                              <div className='form-group'>
                                <Select className="form-control"
                                  showSearch
                                  allowClear={true}
                                  disabled={isAuditPlanEditMode}
                                  onChange={(value) => {
                                    // setSearchedItem({...searchedItem,auditorId:value})
                                    setAuditPlanFilter({...auditPlanFilter, auditorId: value})
                                  }}
                                  placeholder="-- Select Auditor --"
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                                  }
                                  value={auditPlanFilter.auditorId}
                                >{
                                    tpvList?.AuditorList.map(((item) =>
                                      <Option key={item.id} value={item.id}>{item.auditorName}</Option>
                                    ))
                                  }
                                </Select>
                              </div>
                          </div>
                        { !isUserAuditor &&
                          <div className="col-md-2">
                            <button className='btn muted-button btn-icon deca-btn-yellow' onClick={setPrequisite4AuditPlan} disabled={!isAuditPlanCreate}>
                              Create Audit Plan
                            </button>
                          </div>
                        }
                        <div className={isUserAuditor?"col-md-8 text-right": "col-md-6 text-right"}>
                          <button className='btn muted-button btn-icon deca-btn-yellow' onClick={()=> viewNCDetails(null, null, 'all_nc_list')}>
                            View NC Details
                          </button>
                        </div>
                      </div>
                      <div className="m-table__main">
                          <div className="m-table__responsive large-width">
                          <Table columns={AuditPlanTableColumns} dataSource={auditPlanForm} loading={auditPlanLoading}/>
                          </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 text-right">
                          <div className="m-page__button top-space">
                            <button htmltype="submit" className='btn muted-button  deca-btn-yellow' onClick={_doSubmitAuditPlan} disabled={!enableAuditPlanSubmit}>Submit</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
            )}
          </div>
  
        </div> : null}
        <Footer />
        </>
    )
}
